/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { isEditionAuthorized, isDeletionAuthorized, openFinalRegistrationPage, openEditStudentPreInterviewPage, deleteStudentPreInterviews }
) => (
  <>
    <OverlayTrigger
      overlay={<Tooltip id="student-pre-interview-final-registration-tooltip">Kesin Kayıt Yap</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm"
        onClick={() => openFinalRegistrationPage(row.preInterviewId)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Code/Loading.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>
    {
      isEditionAuthorized &&
      <OverlayTrigger
        overlay={<Tooltip id="student-pre-interview-edit-tooltip">Düzenle</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() => openEditStudentPreInterviewPage(row.preInterviewId)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
           </span>
        </a>
      </OverlayTrigger>
    }
    {
      isDeletionAuthorized &&
      <OverlayTrigger
        overlay={<Tooltip id="student-pre-interview-delete-tooltip">Sil</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm"
          onClick={() => deleteStudentPreInterviews(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    }    
  </>
);